<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "电梯系统",
          "空调系统",
          "消防系统",
          "安防系统",
          "配电系统",
          "办公设备",
        ],
        lineData: [
          18092,
          20728,
          24045,
          48348,
          32808,
          26097
        ],
        barData: [
          4600,
          5000,
          5500,
          6500,
          7500,
          8500
        ]
      },
      data: [
        {
          lineData: [
            18092,
            20728,
            24045,
            48348,
            32808,
            26097
          ],
          barData: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500
          ],
        },
        {
          lineData: [
            16092,
            30728,
            14045,
            28348,
            26808,
            426097
          ],
          barData: [
            2600,
            3000,
            3500,
            3500,
            4500,
            78500
          ],
        },
        {
          lineData: [
            38092,
            50728,
            14045,
            68348,
            22808,
            66097
          ],
          barData: [
            2600,
            4000,
            6500,
            4500,
            5500,
            3500
          ],
        }
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'device 左下'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData = this.data[index].lineData
      this.cdata.barData = this.data[index].barData

      index++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>